
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/faq",
      function () {
        return require("private-next-pages/[slug]/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/faq"])
      });
    }
  